export enum UserRole {
  GTAdmin = 'GT Admin',
  GTAccounts = 'GT Accounts',
  GTSupport = 'GT Support',
  GTInstaller = 'GT Installer',
  BillingAdmin = 'Billing Admin',
  GTSalesperson = 'GT Salesperson',
  GTGrowthAgent = 'GT Growth Agent',
  GTInstallationManager = 'GT Installation Manager',
  GTMarketplace = 'GT Marketplace',
  GTFuelManager = 'GT Fuel Manager',
  GTSetup = 'GT Setup',
  GTFleetManager = 'GT Fleet Manager',
  GTWaybillManager = 'GT Waybill Manager',
  Ctrack = 'Ctrack',
  GTDriver = 'GT Driver',
  DriverPayrollAdmin = 'Driver Payroll Admin',
  GTBETAUser = 'GT BETA User',
  GTAssetIQBetaUser = 'GT Asset IQ Beta User',
  GTFuelManagementBetaUser = 'GT Fuel Management Beta User',
  GTMyDriversBetaUser = 'GT My Drivers Beta User'
}